import { render } from "./FileImageSelector.vue?vue&type=template&id=5c1c632f&scoped=true"
import script from "./FileImageSelector.vue?vue&type=script&lang=js"
export * from "./FileImageSelector.vue?vue&type=script&lang=js"

import "./FileImageSelector.vue?vue&type=style&index=0&id=5c1c632f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c1c632f"]])

export default __exports__